export default __webpack_public_path__ + "assets/apple-icon-180x180.7e2382666988b6b83c99ffb6e83b1f37.png";